<template>
  <div
    class="bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer group overflow-hidden"
    @click="$emit('click', vacation)"
  >
    <div class="aspect-w-16 aspect-h-9 relative overflow-hidden">
      <img
        v-lazy="vacation.metadata.image || vacation.images[0]"
        :alt="vacation.metadata.title"
        class="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
        @error="handleImageError"
      />
      <div class="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
      <!-- Ribbon Badge for Featured Products -->
      <!-- <div v-if="vacation.orderPriority" class="absolute top-0 left-0 w-32 h-32 overflow-hidden">
        <div class="ribbon-badge">
          <span class="ribbon-text">In de kijker</span>
        </div>
      </div> -->
    </div>
    <div class="p-6">
      <h3 class="font-bold text-gray-900 text-lg mb-3 line-clamp-2 group-hover:text-theme transition-colors">
        {{ vacation.metadata.title || vacation.name }}
      </h3>
      <p v-if="vacation.metadata.description" class="text-sm text-gray-600 mb-4 line-clamp-3">
        {{ vacation.metadata.description }}
      </p>
      <div class="flex justify-between items-center">
        <div class="flex flex-wrap gap-1">
          <span
            v-for="category in visibleCategories.slice(0, 2)"
            :key="category"
            class="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-md"
          >
            {{ formatCategory(category) }}
          </span>
        </div>
        <button class="text-theme hover:text-theme-hover text-sm font-semibold flex items-center group-hover:translate-x-1 transition-transform">
          Bekijk 
          <svg class="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    vacation: {
      type: Object,
      required: true
    }
  },
  computed: {
    visibleCategories() {
      if (!this.vacation.metadata?.categories) return [];
      
      const hideLabels = this.$root.shopSettings?.hideLabels || [];
      return this.vacation.metadata.categories.filter(category => 
        !hideLabels.includes(category.toLowerCase())
      );
    }
  },
  methods: {
    handleImageError(event) {
      // Fallback to a placeholder image if the main image fails to load
      event.target.src = 'https://via.placeholder.com/400x300/f3f4f6/6b7280?text=Geen+afbeelding'
    },
    formatCategory(category) {
      // Capitalize first letter and format category names
      return category.charAt(0).toUpperCase() + category.slice(1)
    }
  }
}
</script>

<style scoped>
:root {
  --theme: #A1C517;
  --theme-hover: #BFD962;
}

.text-theme {
  color: var(--theme);
}

.text-theme-hover {
  color: var(--theme-hover);
}

.group-hover\:text-theme:hover {
  color: var(--theme);
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.aspect-w-16 {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
}

.aspect-h-9 img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Ribbon Badge Styles - Diagonal Design */
.ribbon-badge {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, #A1C517 0%, #8FB313 100%);
  padding: 1.5rem 0;
  /* box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25); */
  transform: rotate(-45deg) translate(-40%, 55%) scale(.8);
  transform-origin: top left;
  width: 180px;
  text-align: center;
  z-index: 10;
}

.ribbon-text {
  display: block;
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}
</style> 